import { useEffect } from 'react';
import { useFieldActions } from '../../../../contexts/field-actions-context';
import { DataStatus } from '../../appointment-state';
import { useAppointmentContext } from '../../context/appointment-context';
import { getDateRange, isSameDay } from '../../utils/format-timezone';
export const useSlotSelectedFromTP = ({ setIsReloadingSlots })=>{
    const { appointmentFieldProps, appointmentState, setAppointmentState } = useAppointmentContext();
    const { value: selectedSlot } = appointmentFieldProps;
    const { actions } = useFieldActions();
    useEffect(()=>{
        const slotSelectedByOutSource = async ()=>{
            // When out source select slot from another day ( for example velo user)
            if (selectedSlot?.startDate && appointmentState?.selectedDate && appointmentState?.dataStatus === DataStatus.DONE) {
                const sameDate = isSameDay(new Date(selectedSlot.startDate), appointmentState?.selectedDate);
                if (!sameDate) {
                    setIsReloadingSlots(true);
                    const selectedDate = new Date(selectedSlot.startDate);
                    const { fromDate, toDate } = getDateRange(selectedDate, 8);
                    const [availabilityDatesToUpdate, availabilitySlotsToUpdate] = await Promise.all([
                        actions?.getAvailabilityDates?.({
                            serviceId: appointmentFieldProps?.initialData.service.id,
                            timeZone: appointmentState?.timezone || '',
                            fromDate,
                            toDate
                        }),
                        actions?.getAvailabilitySlots?.({
                            serviceId: appointmentFieldProps?.initialData.service.id,
                            timeZone: appointmentState?.timezone || '',
                            selectedDate
                        })
                    ]);
                    setAppointmentState({
                        availabilityDates: availabilityDatesToUpdate,
                        selectedDate,
                        availabilitySlots: availabilitySlotsToUpdate
                    });
                    setIsReloadingSlots(false);
                }
            }
        };
        slotSelectedByOutSource();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedSlot,
        appointmentState?.dataStatus
    ]);
};

//# sourceMappingURL=index.js.map